import { ApiService } from './api.service';
import { LoginConstants } from 'src/environments/environment';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { apiUrl } from 'src/environments/environment';
import { PayMent } from '../models/payment.model';
import { Constants } from '../constants/constants';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService {
  private basePayUrl: string = apiUrl.MAXGP_HOST_DIRECT;
  storage = null;
  accessToken = '';
  headers = {};

  constructor(private http: HttpClient, private api: ApiService) {
    this.storage = localStorage.getItem('at');

    if (this.storage) {
      const decode = atob(this.storage);
      this.accessToken = JSON.parse(decode);
    }

    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };
  }

  makeTransaction(transData: PayMent, token_uid: string): Observable<PayMent> {
    const headers = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Empresa: 'infodec',
        Authorization: `Bearer ${token_uid}`,
        Apikey: LoginConstants.apiKey,
      }),
    };

    return this.http
      .post<any>(
        `${this.basePayUrl}/webservice/api/V1/flexipay/paylink/`,
        transData,
        headers
      )
      .pipe(catchError(this.handleError));
  }
  getPaymentResult(idTrans): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Empresa: 'infodec',
        apiKeyComercio: LoginConstants.apiKey,
        contrasenaComercio: LoginConstants.passwordCommerce,
        usuarioComercio: LoginConstants.userCommerce,
      }),
    };

    return this.http
      .get<any>(
        `${apiUrl.TRANS_HOST_DIRECT}/api/transaccion/comercio-consulta-transaccion-comercio/${idTrans}`,
        headers
      )
      .pipe(catchError(this.handleError));
  }

  addTransaction(_data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'add',
        data: _data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/transacciones`, body);
  }
  verifyTransaction(_data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'verify_trans',
        data: _data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/transacciones`, body);
  }

  getUserTransactions(id_usuario): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_all_by_id_user',
        data: { id_usuario: id_usuario },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/transacciones`, body);
  }
  private handleError(errorResponse: HttpErrorResponse) {
    return throwError(errorResponse);
  }
}
